import React from "react";

export default function PickupForm({
  displayName,
  notes,
  setNotes,
}) {
  return (
    <section>
      <div className="space-y-6 p-2">
        <div>
          <h2 className="text-xl font-semibold text-black">Pickup Details</h2>
          <p className="text-sm text-black/60">
            Confirm your details before placing your order.
          </p>
        </div>

        <div>
          <label className="mb-2 block text-sm font-medium text-black">
            Your Name
          </label>
          <input
            type="text"
            value={displayName}
            readOnly
            required
            className="w-full rounded-2xl border border-black/20 bg-black/5 px-4 py-3.5 text-sm text-black outline-none"
          />
        </div>

        <div>
          <label className="mb-2 block text-sm font-medium text-black">
            Notes <span className="text-black/50">(optional)</span>
          </label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={5}
            placeholder="Add any extra instructions"
            className="w-full resize-none rounded-2xl border border-black/20 bg-white px-4 py-3.5 text-sm text-black outline-none transition focus:border-[#fa9324] focus:ring-4 focus:ring-[#fa9324]/20"
          />
        </div>
      </div>
    </section>
  );
}